<span class="title2" *ngIf="!aampUsedQuotaList">Loading, Please wait...</span>
<div class="chart_style" *ngIf="aampUsedQuotaList && aampUsedQuotaList.length > 0">
    <canvas baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptionsNovo"
            [legend]="barChartLegend"
            [type]="barChartType"
></canvas>
</div>
<!-- [colors]="colorArray"> -->
